const STATIC_BASE_URLS = {
  production: 'https://aviata.kz/static',
  staging: 'https://aviax-freedom-travel.dev.cloud.aviata.team/static',
} as const;

const STATIC_BASE_URL =
  import.meta.env.VITE_RUNTIME_ENV === 'production'
    ? STATIC_BASE_URLS.production
    : STATIC_BASE_URLS.staging;

export const staticUrls = {
  airlineLogoUrl: (iata: string, size = '80x80') =>
    `${STATIC_BASE_URL}/airline-logos/${size}/${iata}.png`,

  jasylJumaBannersBase: `${STATIC_BASE_URL}/frontend/freedom-miniapps/jasyl-juma/banners/avia`,

  flightDelayPayoutRequestDoc: `${STATIC_BASE_URL}/frontend/freedom-miniapps/documents/flight-delay/payout-request-doc.pdf`,

  flightDelayFormRequestDoc: `${STATIC_BASE_URL}/frontend/freedom-miniapps/documents/flight-delay/request-form-doc.pdf`,

  countryFlagUrl: (code: string) =>
    `https://dict-cdn.aviata.kz/countries/${code}.svg`,
};
